/**
 * PCM care plan — one disease pack. Not used for RPM.
 */
import React, { forwardRef } from 'react';
import DiseaseCarePlanWorkspace from '../DiseaseCarePlan/DiseaseCarePlanWorkspace';

const PCMCarePlanPanel = forwardRef(({
  enrollmentId,
  patient,
  readOnly = false,
  onBillingRefresh,
  onPlansChange,
  practiceCaregivers = [],
  practiceProviders = [],
  canReview = false,
}, ref) => (
  <DiseaseCarePlanWorkspace
    ref={ref}
    program="PCM"
    enrollmentId={String(enrollmentId || '')}
    patient={patient}
    readOnly={readOnly}
    onBillingRefresh={onBillingRefresh}
    onPlansChange={onPlansChange}
    practiceCaregivers={practiceCaregivers}
    practiceProviders={practiceProviders}
    canReview={canReview}
  />
));

export default PCMCarePlanPanel;
